import React from 'react';
import Spinner from 'src/view/shared/Spinner';
import FirmaFormPage from '../form/FirmaFormPage';

function FirmaView(props) {
  const renderView = () => {
    const {record, drawer} = props;

    return <FirmaFormPage record={record} disabled={true} drawer={drawer} />;
  };

  const {record, loading} = props;

  if (loading || !record) {
    return <Spinner />;
  }

  return renderView();
}

export default FirmaView;
